export function DoPushEvent(store, data) {}
